"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const weths_1 = require("../../config/contracts/weths");
class OnchainAccountPoolToken {
    constructor() {
        this.cache = {};
        this.getPoolToken = () => this.poolToken;
        // Shortcuts
        this.getAccountAddress = () => this.getAccount().getAccountAddress();
        this.getNetwork = () => this.getAccount().getOnchain().network;
        this.getEth = () => this.getAccount().getOnchain().web3.eth;
        this.getDust = () => this.getAccount().getOnchain().dust;
        this.getLiquidityBuffer = () => this.getAccount().getOnchain().liquidityBuffer;
        this.getUiMargin = () => this.getAccount().getOnchain().uiMargin;
        this.getTokenPriceAccurate = () => __awaiter(this, void 0, void 0, function* () { return (yield this.poolToken.getOffchainPoolToken()).getTokenPriceAccurate(); });
    }
    cleanCache() {
        this.cache = {};
    }
    // Available Balance
    initializeAvailableBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield this.poolToken.getToken();
            if (token._address.toLowerCase() == weths_1.WETH[this.getNetwork()].toLowerCase()) {
                return (yield this.getEth().getBalance(this.getAccountAddress())) / 1e18;
            }
            const balance = yield token.methods.balanceOf(this.getAccountAddress()).call();
            return (yield this.poolToken.normalize(balance));
        });
    }
    getAvailableBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cache.availableBalance)
                this.cache.availableBalance = this.initializeAvailableBalance();
            return this.cache.availableBalance;
        });
    }
    getAvailableBalanceUSD() {
        return __awaiter(this, void 0, void 0, function* () {
            const availableBalance = yield this.getAvailableBalance();
            const tokenPrice = yield this.getTokenPriceAccurate();
            return availableBalance * tokenPrice;
        });
    }
    // Deposited
    initializeDeposited() {
        return __awaiter(this, void 0, void 0, function* () {
            const poolToken = yield this.poolToken.getPoolToken();
            const exchangeRate = yield this.poolToken.getExchangeRate();
            const balance = yield poolToken.methods.balanceOf(this.getAccountAddress()).call();
            return (yield this.poolToken.normalize(balance)) * exchangeRate;
        });
    }
    getDeposited() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cache.deposited)
                this.cache.deposited = this.initializeDeposited();
            return this.cache.deposited;
        });
    }
    getDepositedUSD() {
        return __awaiter(this, void 0, void 0, function* () {
            const deposited = yield this.getDeposited();
            const tokenPrice = yield this.getTokenPriceAccurate();
            return deposited * tokenPrice;
        });
    }
    // Max Withdrawable
    getMaxWithdrawable() {
        return __awaiter(this, void 0, void 0, function* () {
            const deposited = (yield this.getDeposited()) * this.getDust();
            const availableCash = (yield this.poolToken.getTotalBalance()) * (1 - this.getLiquidityBuffer());
            return Math.min(deposited, availableCash);
        });
    }
}
exports.default = OnchainAccountPoolToken;
